import React from "react";
import PortfolioLower from "./portfolioLower";
export default function Portfolio() {
    return (
        <>
        <div className="h-full bg-white">
          
          <PortfolioLower />
        </div>
        </>
    )
}